import { useLogout, useGetIdentity } from "react-admin";
import {
  Typography,
  Grid,
  Box,
  Hidden,
  Divider,
  IconButton,
} from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import PowerSettingsNewIcon from "@material-ui/icons/PowerSettingsNew";
import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import DialogBranchSelection from "./DialogBranchSelection";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import SimplePopupDialog from "./SimplePopupDialog";
import { usePopup } from "react-hook-popup";

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.down("sm")]: {
      width: 64,
    },
    marginRight: 10,
    height: 64,
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end"
    // alignSelf: "right",
  },
  avatar: {
    height: 44,
    width: 44,
    marginTop: 8,
    marginLeft: 8,
  },
  nameContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  fullName: {
    color: "white",
    fontSize: 20,
  },
  positionName: {
    color: "white",
    fontSize: 10,
  },
}));

const MyCustomIcon = () => {
  const classes = useStyles();
  const { identity, loading, loaded, error } = useGetIdentity();
  const [showSelectBranch, setShowSelectBranch] = useState(false);
  if (loading) return null;
  if (error) return null;

  if (loaded && error) {
    return null;
  }
  return (
    <Grid className={classes.container}>
      <Hidden smDown>
        <Grid className={classes.nameContainer}>
          <Box onClick={() => setShowSelectBranch(true)}>
            <Typography className={classes.fullName} align="right">
              {identity.firstname} {identity.lastname}
            </Typography>
            <Typography className={classes.positionName} align="right">
              {identity.branchName}
            </Typography>
          </Box>
        </Grid>
      </Hidden>
      <Grid item>
        <Avatar
          className={classes.avatar}
          src={identity.avatar}
          alt={identity.firstname[0]}
        />
      </Grid>
      {showSelectBranch ? (
        <DialogBranchSelection onClose={() => setShowSelectBranch(false)} />
      ) : null}
    </Grid>
  );
};

const MyUserMenu = () => {
  const history = useHistory();
  const logout = useLogout();
  // const classes = useStyles();

  const [showPopup] = usePopup("Logout", ({ message, handleClose }) => (
    <SimplePopupDialog
      handleClose={handleClose}
      onConfirm={message?.onConfirm}
      logout={true}
    />
  ));

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end"
      }}
    >
      <MyCustomIcon />
      <Divider orientation="vertical" flexItem />
      <Box >
        <IconButton
          style={{ width: 70, height: 70 }}
          onClick={() => history.push("/management")}
        >
          <SettingsIcon />
        </IconButton>
      </Box>

      <Box style={{ marginTop: 1 }}>
        <IconButton
          variant="contained"
          style={{ width: 70, height: 70 }}
          onClick={() => {
            showPopup({
              title: "Log out",
              message: "Are you sure?",
              onConfirm: () => {
                logout();
              },
              haveCanceltoClose: true,
            });
            //logout();
          }}
        >
          <PowerSettingsNewIcon />
        </IconButton>
      </Box>
    </Box>
  );
};
export default MyUserMenu;
